export const SET_LOADING = "setLoading";
export const SET_ERROR = "setError";
export const SET_RESET = "setReset";
export const SET_EVENT = "setEvent";
export const SET_EVENT_CAT = "setEventCat";
export const SET_GALLERY = "setEvent";
export const SET_ALL_EVENT = "setAllEvent";
export const SET_OPENING = "setOpening";
export const SET_EXHIBITION = "setExhibition";
export const SET_SOCIAL_RESPONSIBILITIES = "setSocial";
export const SET_BLOG = "setBlog";
export const SET_PROJECTS = "setProjects";
export const SET_All_PROJECTS = "setAllProjects";
export const SET_SINGLE = "setSingle";


